<template>
  <div id="bg-image">
    <review-details-page />
  </div>
</template>

<script>
import ReviewDetailsPage from '../process/Register/ReviewDetailsPage.vue';
    export default {
        name: 'ReviewDetails',
        components: {
            ReviewDetailsPage,
        },
    };
</script>

<style scoped>

</style>
